import request from "@/router/axios";
import crypto from "@/util/crypto.js";

const decryptTransform = (data) => {
  //解密

  try {
    // 解密
    const backdata = crypto.decrypt(data);
    return backdata;
  } catch (error) {
    // 处理解密过程中的异常
    const backdata = data;
    return backdata;
  }
};

const encryption = (data) => {
  let text = JSON.stringify(data);
  let key = crypto.encrypt(text);
  let formData = new FormData();
  formData.append("data", key);
  return formData;
};

const encryptParams = (data) => {
  console.log(crypto.encrypt(JSON.stringify(data)));
  return crypto.encrypt(JSON.stringify(data));
};

//获取客户群详情
export const getCustomerGroupDetails = (data) => {
  let formData = encryption(data);
  return request({
    url: "/api/ygj-integration/v1.0/group-chat/get-group-chat-detail",
    method: "post",
    data: formData,
    transformResponse: [decryptTransform],
  });
};

//企微客户群明细分页列表【企微端】
export const getGroupChatList = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-chat/page-group-detail",
    method: "GET",
    params,
  });
};


//查询患者企微客户的群列表
//http://192.168.0.201:30800/doc.html#/%E7%AC%AC%E4%B8%89%E6%96%B9%E9%9B%86%E6%88%90/[%20web%E5%89%8D%E7%AB%AF%20]%20%E4%BC%81%E5%BE%AE%E5%A4%96%E9%83%A8%E8%81%94%E7%B3%BB%E4%BA%BA%E4%BF%A1%E6%81%AF/listGroupChatUsingGET

export const getExternalUserGroupChatList = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/external-user/list-group-chat",
    method: "GET",
    params,
  });
};

/** 查询群模板列表 — GET /ygj-integration/v1.0/group-template/list */
export const getGroupTemplateList = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-template/list",
    method: "GET",
    params,
  });
};

/** 根据患者查询群模板列表 — GET /ygj-integration/v1.0/group-template/list-by-patient */
export const getGroupTemplateListByPatient = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-template/list-by-patient",
    method: "GET",
    params,
  });
};



/** 群模板详情 — GET /ygj-integration/v1.0/group-template/get/{id} */
export const getGroupTemplateDetail = (id) => {
  return request({
    url: `/api/ygj-integration/v1.0/group-template/get/${id}`,
    method: "GET",
  });
};

/** 新增群模板 — POST /ygj-integration/v1.0/group-template/submit */
export const submitGroupTemplate = (data) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-template/submit",
    method: "POST",
    data,
  });
};

/** 修改群模板 — PUT /ygj-integration/v1.0/group-template/update */
export const updateGroupTemplate = (data) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-template/update",
    method: "PUT",
    data,
  });
};

/** 删除群模板 — DELETE /ygj-integration/v1.0/group-template/delete */
export const deleteGroupTemplate = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-template/delete",
    method: "DELETE",
    params,
  });
};

/** 根据群模板配置获取群成员 — GET /ygj-integration/v1.0/group-template/get-member-by-id */
export const getGroupTemplateMembersById = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-template/get-member-by-id",
    method: "GET",
    params,
  });
};


//前端通过接口建群通知后端
/** 建群通知 — POST /ygj-integration/v1.0/group-chat/create-group-notice */
export const createGroupNotice = (data) => {
  console.log('调用了通知接口',data);
  return request({
    url: "/api/ygj-integration/v1.0/group-chat/create-group-notice",
    method: "POST",
    data,
  });
};

//全部群聊分页列表
/** 管理端全部群聊分页列表 — GET /ygj-integration/v1.0/group-chat/admin-page */
export const getAdminGroupChatPage = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-chat/admin-page",
    method: "GET",
    params,
  });
};



/** 获取我参与的群聊分页列表 — GET /ygj-integration/v1.0/group-chat/my-page */
export const getMyGroupChatPage = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-chat/my-page",
    method: "GET",
    params,
  });
};

/** 批量创建群添加成员任务 — POST /ygj-integration/v1.0/group-chat-member-task/batch-create */
export const batchCreateGroupChatMemberTask = (data) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-chat-member-task/batch-create",
    method: "POST",
    data,
  });
};


/** 获取群成员任务分页列表 — GET /ygj-integration/v1.0/group-chat-member-task/page */
export const getGroupChatMemberTaskPage = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-chat-member-task/page",
    method: "GET",
    params,
  });
};

/** 修改群成员任务状态 — PUT /ygj-integration/v1.0/group-chat-member-task/update-status/{id} */
export const updateGroupChatMemberTaskStatus = (id, params) => {
  return request({
    url: `/api/ygj-integration/v1.0/group-chat-member-task/update-status/${id}`,
    method: "PUT",
    params,
  });
};

//批量取消我的任务
/** 批量取消我的任务 — PUT /ygj-integration/v1.0/group-chat-member-task/batch-cancel */
export const batchCancelGroupChatMemberTask = (data) => {
  return request({
    url: "/api/ygj-integration/v1.0/group-chat-member-task/batch-cancel",
    method: "PUT",
    data,
  });
};

/** 获取企微员工信息（通过员工ID）— GET /ygj-integration/v1.0/wecom-user/get-by-employee */
export const getWecomUserByEmployeeApi = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/wecom-user/get-by-employee",
    method: "GET",
    params,
  });
};